import { render, staticRenderFns } from "./CreateKeyModal.vue?vue&type=template&id=220ebd6a&scoped=true"
import script from "./CreateKeyModal.vue?vue&type=script&lang=js"
export * from "./CreateKeyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ebd6a",
  null
  
)

export default component.exports